import { GenesysConfig } from "../livechat.types";

// Livechat configuration
/* eslint-disable @typescript-eslint/naming-convention */
export const LIVECHAT_CONFIGURATION: GenesysConfig = {
    widgets: {
        main: {
            theme: "hermes",
            themes: {
                hermes: "cx-theme-hermes",
            },
            timeFormat: 12,
            lang: "en",
            downloadGoogleFont: false,
            i18n: {
                de: {
                    webchat: {
                        AgentConnected:
                            "Ein Berater ist der Unterhaltung beigetreten",
                        AgentDisconnected:
                            "Der Berater hat die Unterhaltung verlassen",
                        ChatEnded: "",
                        ChatStarted: "",
                        ChatTitle: "Nachricht",
                        ChatInputPlaceholder: "Ihre Nachricht",
                        ChatFormSubmit: "Weiter",
                        AriaChatFormSubmit: "Weiter",
                        ChatInputSend: "Senden",
                        AriaChatInputSend: "Senden",
                        todayLabel: "Heute",
                    },
                },
                en: {
                    webchat: {
                        AgentConnected: "Client service advisor connected",
                        AgentDisconnected: "Advisor left the chat",
                        ChatEnded: "",
                        ChatStarted: "",
                        ChatTitle: "Message",
                        ChatInputPlaceholder: "Your message",
                        ChatFormSubmit: "Continue",
                        AriaChatFormSubmit: "Continue",
                        ChatInputSend: "Send",
                        AriaChatInputSend: "Send",
                        todayLabel: "Today",
                    },
                },
                es: {
                    webchat: {
                        AgentConnected:
                            "Un asesor se ha unido a la conversación",
                        AgentDisconnected:
                            "El asesor ha salido de la conversación",
                        ChatEnded: "",
                        ChatStarted: "",
                        ChatTitle: "Mensaje",
                        ChatInputPlaceholder: "Su mensaje",
                        ChatFormSubmit: "Continuar",
                        AriaChatFormSubmit: "Continuar",
                        ChatInputSend: "Enviar",
                        AriaChatInputSend: "Enviar",
                        todayLabel: "Hoy",
                    },
                },
                fr: {
                    webchat: {
                        AgentConnected:
                            "Un conseiller a rejoint la conversation",
                        AgentDisconnected:
                            "Le conseiller a quitté la conversation",
                        ChatEnded: "",
                        ChatStarted: "",
                        ChatTitle: "Message",
                        ChatInputPlaceholder: "Votre message",
                        ChatFormSubmit: "Continuer",
                        AriaChatFormSubmit: "Continuer",
                        ChatInputSend: "Envoyer",
                        AriaChatInputSend: "Envoyer",
                        todayLabel: "Aujourd'hui",
                    },
                },
                it: {
                    webchat: {
                        AgentConnected:
                            "Un consulente partecipa alla conversazione",
                        AgentDisconnected:
                            "Il consulente ha abbandonato la conversazione",
                        ChatEnded: "",
                        ChatStarted: "",
                        ChatTitle: "Messaggio",
                        ChatInputPlaceholder: "Il Suo messaggio",
                        ChatFormSubmit: "Continuare",
                        AriaChatFormSubmit: "Continuare",
                        ChatInputSend: "Inviare",
                        AriaChatInputSend: "Inviare",
                        todayLabel: "Oggi",
                    },
                },
                ja: {
                    webchat: {
                        AgentConnected: "スタッフが会話に参加しました",
                        AgentDisconnected: "スタッフが会話から退出しました",
                        ChatEnded: "",
                        ChatStarted: "",
                        ChatTitle: "チャットメッセージ",
                        ChatInputPlaceholder: "メッセージを入力してください",
                        ChatFormSubmit: "チャットをはじめる",
                        AriaChatFormSubmit: "チャットをはじめる",
                        ChatInputSend: "送信する",
                        AriaChatInputSend: "送信する",
                        todayLabel: "本日の受付時間のご案内",
                    },
                },
                ko: {
                    webchat: {
                        AgentConnected: "고객센터 직원과 연결 완료",
                        AgentDisconnected: "직원이 채팅방을 나갔습니다",
                        ChatEnded: "",
                        ChatStarted: "",
                        ChatTitle: "메시지",
                        ChatInputPlaceholder: "나의 메시지",
                        ChatFormSubmit: "계속",
                        AriaChatFormSubmit: "계속",
                        ChatInputSend: "보내다",
                        AriaChatInputSend: "보내다",
                        todayLabel: "오늘",
                    },
                },
                "zh-Hant": {
                    webchat: {
                        AgentConnected: "線上",
                        AgentDisconnected: "離線",
                        ChatEnded: "",
                        ChatStarted: "",
                        ChatTitle: "訊息框",
                        ChatInputPlaceholder: "輸入訊息",
                        ChatFormSubmit: "繼續",
                        AriaChatFormSubmit: "繼續",
                        ChatInputSend: "發送",
                        AriaChatInputSend: "發送",
                        todayLabel: "今日",
                    },
                },
                "zh-Hans": {
                    webchat: {
                        AgentConnected: "已连接客服顾问",
                        AgentDisconnected: "顾问已离开聊天室",
                        ChatEnded: "",
                        ChatStarted: "",
                        ChatTitle: "信息",
                        ChatInputPlaceholder: "您的信息",
                        ChatFormSubmit: "下一步",
                        AriaChatFormSubmit: "下一步",
                    },
                },
            },
        },
        webchat: {
            transport: {
                type: "purecloud-v2-sockets",
                interactionData: {
                    routing: {
                        targetType: "QUEUE",
                        targetAddress: "TST_QUEUE",
                        priority: 2,
                    },
                },
                dataURL: "",
                deploymentKey: "",
                orgGuid: "",
            },
            emojis: false,
            uploadsEnabled: false,
            confirmFormCloseEnabled: true,
            maxMessageLength: 9999,
            charCountEnabled: false,
            inviteOnRestoreTimeout: false,
            userData: {
                storeview: "",
            },
        },
    },
};
/* eslint-enable @typescript-eslint/naming-convention */

// Livechat events
export const LIVECHAT_ACTION_WEBCHAT_READY = "WebChat.ready";
export const LIVECHAT_ACTION_WEBCHAT_CLOSED = "WebChat.closed";
export const LIVECHAT_ACTION_WEBCHAT_MINIMIZE = "WebChat.minimize";
export const LIVECHAT_ACTION_WEBCHAT_MINIMIZED = "WebChat.minimized";
export const LIVECHAT_ACTION_WEBCHAT_OPEN = "WebChat.open";
export const LIVECHAT_ACTION_WEBCHAT_OPENED = "WebChat.opened";
export const LIVECHAT_ACTION_WEBCHAT_UNMINIMIZED = "WebChat.unminimized";
export const LIVECHAT_ACTION_WEBCHAT_MESSAGE_ADDED = "WebChat.messageAdded";
export const LIVECHAT_ACTION_WEBCHAT_COMPLETED = "WebChat.completed";
export const LIVECHAT_ACTION_WEBCHAT_CANCELLED = "WebChat.cancelled";
export const LIVECHAT_ACTION_WEBCHAT_SUBMITTED = "WebChat.submitted";
export const LIVECHAT_ACTION_WEBCHAT_INJECT_MESSAGE = "WebChat.injectMessage";
export const LIVECHAT_ACTION_WEBCHAT_END_CHAT = "WebChat.endChat";
export const LIVECHAT_COOKIE_UNREAD_MESSAGE_COUNT =
    "_genesys.widgets.webchat.state.asyncUnreadMessageCount";
export const CS_MASK = "data-cs-mask";

// Privacy message
export const PRIVACY_TEXT_KEY = "hermes_livechat.privacy_policy_text";
export const PRIVACY_LINK_KEYWORD = "!privacyLink";
export const PRIVACY_LINK_KEY = "hermes_footer.legal.privacy.link.relative";
export const PRIVACY_LINK_TEXT = $localize`:@@hermes_global.i-agree-receiving-information-concerning-offers-services-products-events-privacy-text:Privacy Policy`;

// Icons declaration
export const ICON_CHEVRON =
    '<svg xmlns="http://www.w3.org/2000/svg" width="27px" height="25px"><defs/><symbol id="chevronIcon" viewBox="0 0 25 25"><path fill="none" fill-rule="evenodd" stroke="#444" stroke-linecap="round" stroke-width="1.5" d="M7 12l4 4 4-4"/></symbol><use class="preview" href="#chevronIcon"/></svg>';
export const ICON_SEND =
    '<svg xmlns="http://www.w3.org/2000/svg" width="25px" height="25px"><defs/><symbol id="sendIcon" viewBox="0 0 24 24"><g fill="none" fill-rule="evenodd" stroke="#444" stroke-linejoin="round"><path d="M8.33333333 0l6.53411217 12.3450955-6.53411217 3.5540677-5.67358584 1.0839465z" transform="rotate(45 7.59366642 17.05765211)"/><path stroke-linecap="round" d="M13.9962519 12.4678409l3.592666 2.3956608-4.2579428.2126931L2.08856899 3.83378865" transform="rotate(90 10.29076717 13.72129264)"/></g></symbol><use class="preview" href="#sendIcon"/></svg>';
export const ICON_LIVECHAT =
    '<svg xmlns="http://www.w3.org/2000/svg" width="25px" height="25px"><symbol id="livechat" viewBox="0 0 21 21"><g id="chat" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><line id="line-1" x1="7.07142857" y1="9.21428571" x2="11.3571429" y2="9.21428571" stroke="#444444" stroke-width="1.5" stroke-linecap="round"></line><line id="line-2" x1="7.07142857" y1="12.7857143" x2="14.9285714" y2="12.7857143" stroke="#444444" stroke-width="1.5" stroke-linecap="round"></line><path id="path" d="M10.5,0.75 C13.1923882,0.75 15.6298882,1.84130592 17.3942911,3.60570888 C19.1586941,5.37011184 20.25,7.80761184 20.25,10.5 C20.25,13.1923882 19.1586941,15.6298882 17.3942911,17.3942911 C15.6298882,19.1586941 13.1923882,20.25 10.5,20.25 C8.54447884,20.25 6.72332233,19.6745028 5.19699549,18.6832013 C4.32788288,18.6064364 3.46976234,18.7786208 2.08018938,19.0880802 C2.60111004,17.0943576 2.62397963,16.2485432 2.60672611,16.2247985 C1.43866248,14.6172832 0.75,12.6390383 0.75,10.5 C0.75,7.80761184 1.84130592,5.37011184 3.60570888,3.60570888 C5.37011184,1.84130592 7.80761184,0.75 10.5,0.75 Z" stroke="#444444" stroke-width="1.5"></path></g></symbol><use href="#livechat" class="preview"><style type="text/css">#chat {stroke-width: 1;stroke: none;}#line-1, #line-2 {stroke: #444;stroke-width: 1.5;stroke-linecap: round;}#path {stroke-width: 1.5;stroke: #444;}</style></use></svg>';

export const AWAY_MESSAGE_TIMER = 86_400_000;
export const DISCONNECT_MESSAGE_TIMER = 86_400_000;

export const AWAY_MESSAGE = "hermes_livechat.away_message";
export const DISCONNECT_MESSAGE = "hermes_livechat.disconnect_message";
